import {Injectable} from '@angular/core';

@Injectable()
export class UserLoggedRolesServiceService {

  constructor() {
  }

  public userHasRole(user: any, roleName: string) {
    if (!user || !user.roles || !user.roles.length) {
      return false;
    }
    return !!user.roles.includes(roleName);
  }

  public userHasOneOfThoseRoles(user: any, rolesNames: string[]) {
    if (!user || !user.roles) {
      return false;
    }
    for (const roleName of rolesNames) {
      if (user.roles.includes(roleName)) {
        return true;
      }
    }
    return false;
  }
}
